import { TellentOrgAbilities } from '@core/tellent-types';

import type {
  AbilitiesCheckPair,
  AbilityEditLevel,
  AbilityGroupConfig,
  AbilityGroupViewModel,
  SimplifiedMember,
} from './types';

export const isSelf = ({ admin, member }: AbilitiesCheckPair) => admin.userGuid === member.userGuid;

export const canChangeMemberPermissions = (data: AbilitiesCheckPair) =>
  !isSelf(data) && hasTellentAbility(data.admin) && data.member.status !== 'deactivated';

export const hasTellentAbility = (admin: SimplifiedMember) =>
  admin.abilities.includes(TellentOrgAbilities.ManageTellent);

export const describeGroup =
  (id: AbilityEditLevel, desc: AbilityGroupConfig) =>
  (data: AbilitiesCheckPair): AbilityGroupViewModel => ({
    id,
    canView: desc.canView(data),
    canEdit: desc.canEdit(data),
    match: desc.match(data),
    abilities: desc.abilities.map(abilityOrConfig =>
      typeof abilityOrConfig === 'string'
        ? {
            hidden: false,
            id: abilityOrConfig,
            getControlState: data => ({ value: true, disabled: false }),
          }
        : abilityOrConfig,
    ),
  });

export const describeAbility = (ability: TellentOrgAbilities, hidden = false) => ({
  id: ability,
  hidden,
  getControlState: ({ admin, member }: AbilitiesCheckPair) => ({
    value: member.abilities.includes(ability),
    disabled: !canChangeMemberPermissions({ admin, member }),
  }),
});

export const describeStructureAbility = (
  hidden: boolean,
  getControlState: () => { value: boolean; disabled: boolean },
) => ({
  id: TellentOrgAbilities.ManageStructure,
  hidden,
  getControlState,
});

export const buildGroups = (
  vms: Array<ReturnType<typeof describeGroup>>,
  { admin, member }: AbilitiesCheckPair,
) => vms.map(vm => vm({ admin, member }));
